const permissao = {
    methods: {
        verificarPermissao(hash) {
            if (!hash) return true

            const autenticacao = this.$store.state.autenticacao

            if (!autenticacao) return false

            const permissoes = autenticacao.permissoes

            if (!permissoes) return false

            return !!permissoes.find(permissao => {
                return !!permissao.endpointAcoes.find(endpointAcao => {
                    return `${endpointAcao.nome}-${permissao.funcionalidade.modulo.identificador}-${permissao.funcionalidade.identificador}` == hash
                })
            })

        }
    },
}

export default permissao